import store from '@state/store'

let axiosBase = require('axios')

axiosBase.interceptors.response.use(function (response) {

    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export const axios = {

    getAppCredentials() {
        return store.state.appAuth.appSession
            ? `key ${store.state.appAuth.appSession.key}` : ''
    },
    defaultOptions(options, delete_data = null) {
        let extraOptions = {
            headers: {
                'Authorization': store.state.auth.currentSession
                    ? `key ${store.state.auth.currentSession.key}` : '',
                'Accept-Language': store.state.language.language
                    ? store.state.language.language : 'es'
            }
        }
        // appRequest makes the request auto-authenticable (no-user login required)
        // axios uses in-app-auth built-in instead
        if ('appRequest' in options && options.appRequest) {
            delete options["appRequest"];
            extraOptions.headers['Authorization'] = this.getAppCredentials()
        }
        if ('headers' in options && options.headers) {
            extraOptions.headers = {
                ...extraOptions.headers,
                ...options.headers
            }
            delete options.headers
        }
        let dict = {
            ...extraOptions,
            ...options
        }


        if (delete_data) {
            dict['data'] = delete_data
        }
        return dict

    },
    get(url, options = {}) { return axiosBase.get(url, this.defaultOptions(options)) },
    post(url, data, options = {}) { return axiosBase.post(url, data, this.defaultOptions(options)) },
    patch(url, data, options = {}) { return axiosBase.patch(url, data, this.defaultOptions(options)) },
    put(url, data, options = {}) { return axiosBase.put(url, data, this.defaultOptions(options)) },
    delete(url, data, options = {}) { return axiosBase.delete(url, this.defaultOptions(options, data)) },
}

export default axios